import type { Offer } from '@fourthwall/services/dist/models/offer'

import type { Item, OfferItem, SingleVariantOfferItem, VariantItem } from '../SelectItems.types'

export const getItemsFromOffers = (
  offers: Offer.Item[] | undefined,
  notAvailableOffersIds?: string[],
): Item[] => {
  if (!offers || !offers.length) return []

  return offers.reduce<Item[]>((previous, current) => {
    if (notAvailableOffersIds && notAvailableOffersIds.includes(current.id)) return previous

    if (current.variants.length < 2) {
      const singleVariantOffer: SingleVariantOfferItem = {
        type: 'SINGLE_VARIANT_OFFER',
        offerId: current.id,
        name: current.name,
        image: current.primaryImage?.thumbnail.url,
        variantId: current.variants[0].id,
        stock: current.variants[0].quantity,
        price: current.variants[0].cost,
        oldPrice: current.variants[0].price,
        disabled: current.variants[0].quantity === 0,
      }

      return [...previous, singleVariantOffer]
    }

    const offer: OfferItem = {
      type: 'OFFER',
      offerId: current.id,
      name: current.name,
      image: current.primaryImage?.thumbnail.url,
    }

    const offerVariants = current.variants.map<VariantItem>((variant) => ({
      type: 'VARIANT',
      variantId: variant.id,
      name: variant.attributesDescription,
      color:
        variant.colorAttribute && variant.colorAttribute.colorSwatch
          ? {
              label: variant.colorAttribute.name,
              value: variant.colorAttribute.colorSwatch,
            }
          : undefined,
      stock: variant.quantity,
      price: variant.cost,
      oldPrice: variant.price,
      disabled: variant.quantity === 0,
    }))

    return [...previous, offer, ...offerVariants]
  }, [])
}
